import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getPrimaryOwnerFromParties = (parties) => {
  return filterPartiesByPartyTypeCode(parties, ["OW"])[0];
};
